import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  title: 'What we have to offer',
  item1: 'Flexible home office days',
  item2: 'Flex-time for early risers and night owls',
  item3: 'A dog-friendly working environment',
  item4: 'A secure and long-term job',
  item5: 'Company pension plan with employer subsidy possible',
  item6: 'Regular exchange, feedbacks, team meetings & retrospectives',
  item7: 'Monthly Company Breakfast',
  item10: 'Room for own ideas and personal development',
  item11: 'Digital training courses, available to every employee at his or her own discretion',
  item12: 'Subsidy for Urban Sports Club membership',
  item13: 'Subsidy for Deutschlandticket',
  item14: 'Bike leasing via JobRad',
  item15: 'Support with relocating processes',
  item16: 'Free German courses for newcomers'
})
